/**
 * Creating new Event that is compatible with all browsers (including IE9+).
 * Source: https://stackoverflow.com/a/42089476
 *
 * @param eventName
 */
export function createNewEvent(eventName: string): Event {
  if (typeof Event !== "function") {
    const event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
    return event;
  }

  return new Event(eventName, {
    cancelable: true,
  });
}
